export default __webpack_public_path__ + "static/media/bank-icon.398232d9.svg";